import styled, { keyframes } from 'styled-components';

export type BadgeProps = { color: string };

export const Badge = styled.span<BadgeProps>`
  display: inline-block;
  min-width: 6rem;
  padding: 0 0.9rem;
  border: 0.1rem solid transparent;
  border-radius: 1rem;

  background-color: ${({ color }) => color};
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
  letter-spacing: 0.1rem;
  text-align: center;
  text-transform: uppercase;
  word-break: break-word;
`;

const blinkAnimation = keyframes`
0% {opacity: 0;}
50% {opacity: 1;}
100% {opacity: 0;}
`;

export const BlinkingBadge = styled(Badge)`
  animation-name: ${blinkAnimation};
  animation-duration: 2s;
  animation-iteration-count: infinite;
`;
